// removed by extract-text-webpack-plugin
module.exports = {"link":"RouterLink__link__2scvq"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/RouterLink/RouterLink.scss
// module id = 1288
// module chunks = 0